import React from 'react';
import { component } from 'picoapp';
import { render } from 'react-dom';
import Recommendations from './Recommendations';
import { QueryClient, QueryClientProvider } from 'react-query';

export default component((node, ctx) => {
  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);
          render(
            <QueryClientProvider client={new QueryClient()}>
              <Recommendations {...Object.fromEntries(props)}></Recommendations>
            </QueryClientProvider>,
            this
          );
        }
      }
    );
  }
});

// export default component((node, ctx) => {
//   if (!customElements.get('product-recommendations')) {
//     customElements.define(
//       'product-recommendations',
//       class ProductRecommendations extends HTMLElement {
//         constructor() {
//           super();
//           this.init();
//         }
//         init() {
//           const handleIntersection = (entries, observer) => {
//             if (!entries[0].isIntersecting) return;
//             observer.unobserve(this);

//             fetch(this.dataset.url)
//               .then((response) => response.text())
//               .then((text) => {
//                 const html = document.createElement('div');
//                 html.innerHTML = text;
//                 const recommendations = html.querySelector('product-recommendations');

//                 if (recommendations && recommendations.innerHTML.trim().length) {
//                   this.innerHTML = recommendations.innerHTML;
//                 }

//                 if (html.querySelector('.Card')) {
//                   this.classList.add('product-recommendations--loaded');
//                 }
//               })
//               .catch((e) => {
//                 console.error(e);
//               });
//           };

//           new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
//         }
//       }
//     );
//   }
// });
